import { IonGrid, IonRow, IonCol, IonIcon, IonButton, IonButtons } from '@ionic/react';
import { closeCircleOutline } from 'ionicons/icons';
import React, { useEffect, useMemo, useState } from 'react';

import { KneePositionGraph } from '@/pages/ReportV2/components/Graphs';
import styles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

import { Loading } from '@/components/Loading/Loading';

import { uuid } from '@/utils';

import { KneePositionData } from '@/models/reportV2.model';

type KneePositionsModalContentProps = {
  data: KneePositionData;
  setShowZoomModal: any;
};

function createLegend(): any[] {
  const meanEntry = [
    {
      id: uuid(),
      name: 'Mean',
      color: '#FFC700',
    },
  ];

  const allStridesEntry = [
    {
      id: uuid(),
      name: 'All strides',
      color: '#0A2E2C',
    },
  ];

  return [...meanEntry, ...allStridesEntry];
}

export const KneePositionsModalContent = ({ data, setShowZoomModal }: KneePositionsModalContentProps) => {
  const [loading, setLoading] = useState(true);
  const [legend, setLegend] = useState<any[]>([]);
  const [showAllStrides, setShowAllStrides] = useState<boolean>(true);
  const [activeTabKneePositions, setActiveTab] = useState('All strides');
  const [dataLeft, setDataLeft] = useState<any[]>(data.kneePositionsLeft);
  const [dataRight, setDataRight] = useState<any[]>(data.kneePositionsRight);

  const seriesKneePositionsLeft = useMemo(() => {
    return showAllStrides ? data.kneePositionsLeft : data.kneePositionLeft;
  }, [showAllStrides, data]);

  const seriesKneePositionsRight = useMemo(() => {
    return showAllStrides ? data.kneePositionsRight : data.kneePositionRight;
  }, [showAllStrides, data]);

  // Tab change set the active tab and the data for the graphs.
  const tabChange = (name: string) => {
    localStorage.setItem('activeTabKneePositions', name);
    setActiveTab(name);
    if (name === 'All strides') {
      setShowAllStrides(true);
      //   setDataLeft(data.kneePositionsLeft);
      //   setDataRight(data.kneePositionsRight);
    } else {
      setShowAllStrides(false);
      //   setDataLeft(data.kneePositionLeft);
      //   setDataRight(data.kneePositionRight);
    }
  };

  useEffect(() => {
    const activeTabKneePositions = localStorage.getItem('activeTabKneePositions');
    if (activeTabKneePositions) {
      setActiveTab(activeTabKneePositions);
    } else {
      localStorage.setItem('activeTabKneePositions', 'All strides');
      setActiveTab('All strides');
    }
  });

  useEffect(() => {
    setLegend(createLegend());
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [data]);

  const cleanUp = () => {
    localStorage.setItem('activeTabKneePositions', 'All strides');
    setShowAllStrides(true);
    setShowZoomModal({ show: false, graph: '' });
  };

  return (
    <>
      <IonGrid className={styles.Modalcontent_container} fixed>
        <IonRow className={styles.variabilityLegend_Row}>
          <IonCol className='' size='11'>
            <div className={styles.variabilityLegend}>
              {legend.map((element, _) => {
                const color = element.color;
                const iconStyle = {
                  backgroundColor: color,
                };

                return (
                  <div
                    className={
                      activeTabKneePositions === element.name
                        ? styles.variabilityLegend_Entry_Selected
                        : styles.variabilityLegend_Entry
                    }
                    key={element.id}
                    onClick={() => {
                      tabChange(element.name);
                    }}>
                    <div className={styles.legend_dot} style={iconStyle} />
                    <p className={styles.legend_name}>{element.name}</p>
                  </div>
                );
              })}
            </div>
          </IonCol>
          <IonCol className='ion-align-items-center' size='1'>
            <IonButtons className='ion-justify-content-center ion-align-self-center' style={{ height: '100%' }}>
              <IonButton className={styles.closeButton} fill='clear' onClick={() => cleanUp()} slot='icon-only'>
                <IonIcon icon={closeCircleOutline} />
              </IonButton>
            </IonButtons>
          </IonCol>
        </IonRow>
        <IonRow className='ion-align-items-center ion-align-items-stretch ion-padding-vertical ion-margin-vertical ion-justify-content-center'>
          {loading && <Loading />}
          {!loading && (
            <>
              <IonCol className='ion-no-padding' size='6'>
                <KneePositionGraph
                  data={seriesKneePositionsLeft}
                  strokeWidth={showAllStrides ? 1 : 2}
                  subtitle={`Max Knee Height: ${data.maxKneePositions.col0[0].toFixed(2) + ' cm'}`}
                  title={'Left'}
                />
              </IonCol>
              <IonCol className='ion-no-padding' size='6'>
                <KneePositionGraph
                  data={seriesKneePositionsRight}
                  strokeWidth={showAllStrides ? 1 : 2}
                  subtitle={`Max Knee Height: ${data.maxKneePositions.col0[0].toFixed(2) + ' cm'}`}
                  title={'Right'}
                />
              </IonCol>
            </>
          )}
        </IonRow>
      </IonGrid>
    </>
  );
};
